import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["resetBtn"]

  connect() {
    this.activeFilters = {
      element: [],
      job: [],
      rating: [],
      faction: []
    }
  }

  toggle(event) {
    const btn = event.currentTarget
    const type = btn.dataset.filterType
    const value = btn.dataset.filterValue

    const index = this.activeFilters[type].indexOf(value)
    if (index === -1) {
      this.activeFilters[type].push(value)
      btn.classList.add("filter-btn-active")
    } else {
      this.activeFilters[type].splice(index, 1)
      btn.classList.remove("filter-btn-active")
    }

    this.applyFilters()
    this.updateResetBtn()
  }

  applyFilters() {
    const cards = document.querySelectorAll(".character-card-link")

    cards.forEach(card => {
      if (card.closest("[data-filter-ignore]")) return
      const ch = card.querySelector(".character-card")
      const element = ch.dataset.element
      const job = ch.dataset.job
      const rating = ch.dataset.rating
      const faction = ch.dataset.faction

      const elementMatch = this.activeFilters.element.length === 0 || this.activeFilters.element.includes(element)
      const jobMatch = this.activeFilters.job.length === 0 || this.activeFilters.job.includes(job)
      const ratingMatch = this.activeFilters.rating.length === 0 || this.activeFilters.rating.includes(rating)
      const factionMatch = this.activeFilters.faction.length === 0 || this.activeFilters.faction.includes(faction)

      card.style.display = elementMatch && jobMatch && ratingMatch && factionMatch ? "" : "none"
    })
  }

  reset() {
    this.activeFilters = { element: [], job: [], rating: [], faction: [] }
    document.querySelectorAll(".filter-btn-active").forEach(btn => btn.classList.remove("filter-btn-active"))
    this.applyFilters()
    this.updateResetBtn()
  }


  updateResetBtn() {
    const hasActive = Object.values(this.activeFilters).some(arr => arr.length > 0)
    if (this.hasResetBtnTarget) {
      this.resetBtnTarget.classList.toggle("filter-reset-active", hasActive)
    }
  }
}
